import React, { useMemo } from 'react'
import { StyleSheet } from 'react-native'
import { v4 as uuidv4 } from 'uuid'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { Image } from 'widgets/Image'
import { Pressable } from 'widgets/Pressable'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

import { useFocusMode } from 'contexts/FocusModeContext'

type LogoButtonProps = {
  onPress: () => void
}

const styles = StyleSheet.create({
  box: {
    width: 36,
    height: 36,
  },
  focusModeBox: {
    width: 36,
    height: 36,
    borderRadius: 10,
    borderColor: 'black',
    borderWidth: 1,
    overflow: 'hidden',
  },
})

export const LogoButton = ({ onPress }: LogoButtonProps) => {
  const focusMode = useFocusMode()
  const isFocusMode = useMemo(() => focusMode.group !== undefined, [focusMode.group])

  return (
    <Pressable onPress={onPress}>
      <Box
        style={!isFocusMode ? styles.box : styles.focusModeBox}
        justifyContent='center'
        align='center'
      >
        {!isFocusMode ? (
          <>
            <Icon name='upspace-gradient-logo-mark' color='white' size={50} />
            <Box position='absolute'>
              <Icon name='upspace-logo-mark' color='white' size={24} />
            </Box>
          </>
        ) : (
          <Image
            cacheKey={
              focusMode.group
                ? // eslint-disable-next-line no-underscore-dangle
                  `${focusMode.group?.id}-program-cover-${focusMode.group?.cover?._original?.etag}-small`
                : uuidv4()
            }
            imageWidth={160}
            source={{ uri: focusMode.group?.cover?.url ?? defaultPostThumbnailUrl }}
            resizeMode='cover'
            style={commonStyles.fullSize}
          />
        )}
      </Box>
    </Pressable>
  )
}
